if (!customElements.get('bienenlie-cart-recommendations')) {
  customElements.define('bienenlie-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.load());
      }
      this.load();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      if (this.controller) this.controller.abort();
    }

    async load() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const list = this.querySelector('[data-bl-cart-list]');
      const error = this.querySelector('[role="alert"]');
      try {
        const cartResponse = await fetch(root + 'cart.js', { signal });
        if (!cartResponse.ok) throw new Error(this.dataset.error);
        const cart = await cartResponse.json();
        if (!cart.items.length) { this.hidden = true; return; }
        const cartIds = new Set(cart.items.map((item) => Number(item.product_id)));
        const anchor = cart.items.reduce((best, item) => Number(item.final_line_price || 0) > Number(best.final_line_price || 0) ? item : best, cart.items[0]);
        const response = await fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(anchor.product_id) + '&limit=10&intent=related', { signal });
        if (!response.ok) throw new Error(this.dataset.error);
        const result = await response.json();
        if (signal.aborted || !this.isConnected) return;
        list.replaceChildren();
        const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: cart.currency || 'EUR' }).format(cents / 100);
        const allowedProducts = new Set([8621755695450,8645851414874,8645868093786,8645869142362,8645871862106,8645878219098,8645879136602,8645879791962,8695020224858,8695044079962,9705426944346,9705430155610,9705434644826,9705436381530,9705437069658,9705438839130,9708576899418,9709573570906,9755953135962,9819796603226,9819840282970,9819842937178,9819856437594,9888584270170,10178766963034,10272331301210,10290254610778,10290258674010,10386811650394,10396814049626,10405665735002,10409359475034,10731241963866,10731403870554,10735702901082,10735821783386,10735889613146,10735932244314,10735973007706,10771012649306,10771374965082,10771729023322,10794147905882,10794150658394,10794151182682,10817172406618,10817196982618,10817199440218,10824679817562,10824696824154,10825265217882,10846823154010,10849692516698,10853126701402,10856869691738,10875939619162,10891701977434,10915380953434,10997510799706,11007149736282,11017771417946,11029114519898,11029114814810,11029115240794,11029115306330,11029117043034,11029139194202,11029139718490,11029139784026,11029139849562,11029139915098,11029140013402,11029140078938,11029140177242]);
        const products = (result.products || []).filter((product) => allowedProducts.has(Number(product.id)) && Number(product.price) > 0 && product.available && !cartIds.has(Number(product.id)) && product.variants.some((variant) => variant.available)).slice(0, 3);
        for (const product of products) {
          const variant = product.variants.find((item) => item.available);
          const row = document.createElement('div');
          row.className = 'bl-cart-page-upsell__item';
          if (product.featured_image) {
            const image = document.createElement('img');
            image.className = 'bl-cart-page-upsell__image';
            const imageUrl = new URL(product.featured_image, window.location.origin);
            if (imageUrl.hostname.endsWith('shopify.com') || imageUrl.pathname.includes('/cdn/shop/')) imageUrl.searchParams.set('width', '112');
            image.src = imageUrl.href;
            image.alt = '';
            image.width = 56;
            image.height = 56;
            image.loading = 'lazy';
            row.append(image);
          }
          const info = document.createElement('div');
          info.className = 'bl-cart-page-upsell__info';
          const link = document.createElement('a');
          link.href = product.url || root + 'products/' + product.handle;
          link.textContent = product.title;
          const price = document.createElement('div');
          price.textContent = money(variant.price);
          info.append(link, price);
          row.append(info);
          const needsSelection = [10771729023322,10825265217882,10846823154010,10849692516698,10853126701402,10856869691738,10875939619162,10915380953434,10997510799706,11029114519898,11029114814810,11029115240794,11029115306330,11029117043034,11029139194202,11029139718490,11029139784026,11029139849562,11029139915098,11029140013402,11029140078938,11029140177242].includes(Number(product.id)) || product.variants.length > 1 || (variant.quantity_rule && (variant.quantity_rule.min > 1 || variant.quantity_rule.increment > 1));
          if (needsSelection) {
            const choose = document.createElement('a');
            choose.className = 'bl-cart-page-upsell__button';
            choose.href = link.href;
            choose.textContent = this.dataset.choose;
            row.append(choose);
          } else {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'bl-cart-page-upsell__button';
            button.textContent = this.dataset.add;
            button.setAttribute('aria-label', product.title + ' · ' + this.dataset.add);
            button.addEventListener('click', async () => {
              button.disabled = true;
              error.hidden = true;
              try {
                const cartItems = document.querySelector('cart-items');
                const sections = cartItems && typeof cartItems.getSectionsToRender === 'function' ? cartItems.getSectionsToRender() : [];
                const payload = { items: [{ id: variant.id, quantity: 1 }] };
                if (sections.length) {
                  payload.sections = sections.map((section) => section.section);
                  payload.sections_url = window.location.pathname;
                }
                const addResponse = await fetch(root + 'cart/add.js', {
                  method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify(payload)
                });
                const added = await addResponse.json();
                if (!addResponse.ok || added.status) throw new Error(added.description || this.dataset.error);
                const updates = sections.map((section) => {
                  const target = document.getElementById(section.id);
                  const html = added.sections && added.sections[section.section];
                  const source = html && new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
                  return { target: target && (target.querySelector(section.selector) || target), source };
                });
                if (!updates.length || updates.some((update) => !update.target || !update.source)) {
                  window.location.reload();
                  return;
                }
                for (const update of updates) update.target.innerHTML = update.source.innerHTML;
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                  await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bienenlie-cart-recommendations', productVariantId: variant.id, cartData: added });
                } else {
                  window.location.reload();
                }
              } catch (failure) {
                error.textContent = failure.message || this.dataset.error;
                error.hidden = false;
                button.disabled = false;
              }
            });
            row.append(button);
          }
          list.append(row);
        }
        this.hidden = products.length === 0;
      } catch (failure) {
        if (failure.name !== 'AbortError') this.hidden = true;
      }
    }
  });
}
